import useStore from "@/store/store";

export default function useRosterStatus() {
  const rosterMade = useStore((state) => state.rosterMade);
  const rosterMadeError = useStore((state) => state.rosterMadeError);
  const rosterInfeasibility = useStore((state) => state.rosterInfeasibility);
  const dismissedJobId = useStore((state) => state.dismissedJobId);
  const setRosterMade = useStore((state) => state.setRosterMade);
  const resetRosterMadeState = useStore((state) => state.resetRosterMadeState);
  const setRosterMadeError = useStore((state) => state.setRosterMadeError);
  const setRosterInfeasibility = useStore(
    (state) => state.setRosterInfeasibility
  );
  const setDismissedJobId = useStore((state) => state.setDismissedJobId);

  return {
    rosterMade,
    rosterMadeError,
    rosterInfeasibility,
    dismissedJobId,
    setRosterMade,
    resetRosterMadeState,
    setRosterMadeError,
    setRosterInfeasibility,
    setDismissedJobId,
  };
}
